module.exports = __webpack_public_path__ + "media/customizations/ranchlife/logo-94efa5fc8bead89905877edafb9e6cab.png";